module.exports = __webpack_public_path__ + "img/onlineErp-3.19739091.png";